import environmentConfig from '@/config/environmentConfig'

export function getTpfHost() {
  return environmentConfig.tpfHost || ''
}

export default function goToTpf() {
  const url = getTpfHost()
  if (!url) {
    console.error('No TPF host configured')
    return false
  }

  window.location.assign(url)
  return true
}
